// src/pages/admin/MerchantCategories.js
import React from "react";
import AdminMerchantCategoriesComp from "../../components/Admin/AdminMerchantCategories";

export default function AdminProductCategoriesPage() {
  return <AdminMerchantCategoriesComp />;
}
